import gql from 'graphql-tag';

export const TransferGiftCardAccount = gql`
  mutation TransferGiftCardAccount($input: TransferGiftCardAccountInput!) {
    transferGiftCardAccount(input: $input) {
      success
      errorCode
      message
    }
  }
`;
